import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { TextInput, Icon } from 'react-orange-ui';

// Position the icon in input field
const PositionIcon = styled.div`
  position: relative;
  
  & > svg {
    position: absolute;
    top: 14px;
    right: 8px;
    cursor: pointer;
    z-index: 1;
  }
`;

class PasswordInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reveal: false,
    };
  }

  handleToggleIcon = (e) => {
    e.preventDefault();
    const { reveal } = this.state;
    const { onEyeIconClick } = this.props;

    if (onEyeIconClick && !reveal) {
      onEyeIconClick();
    }
    this.setState(prevState => ({
      reveal: !prevState.reveal,
    }));
  };

  /**
   * When the 'Space' key is detected, change the reveal icon state
   * @param event
   */
  handleKeyPress = (event) => {
    if (event.key === ' ') {
      this.handleToggleIcon(event);
    }
  };

  render() {
    const {
      id,
      children,
      onFocus,
      onBlur,
      onChange,
      maxLength,
      valid,
      errorMessage,
      value,
    } = this.props;
    const { reveal } = this.state;

    return (
      <TextInput
        id={id}
        type={reveal ? 'text' : 'password'}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        maxLength={maxLength}
        value={value}
        valid={valid}
        errorMessage={errorMessage}
      >
        {children}
        <PositionIcon>
          <Icon
            id={`icon-reveal-${id}`}
            className={reveal ? 'open' : 'closed'}
            role="button"
            aria-pressed={reveal}
            aria-label="Afficher ou cacher le mot de passe"
            tabIndex={0}
            onKeyDown={this.handleKeyPress}
            onClick={this.handleToggleIcon}
            icon={reveal ? 'accessibility-vision' : 'Hide'}
            color="black"
            width={28}
            height={28}
          />
        </PositionIcon>
      </TextInput>
    );
  }
}

PasswordInput.defaultProps = {
  onChange: () => { },
  onFocus: () => { },
  onBlur: () => { },
  onEyeIconClick: undefined,
  valid: true,
  maxLength: 36,
  errorMessage: '',
};

PasswordInput.propTypes = {
  /** String input label */
  children: PropTypes.node.isRequired,
  /** String input id */
  id: PropTypes.string.isRequired,
  /** String input value */
  value: PropTypes.string.isRequired,
  /** Number max length value */
  maxLength: PropTypes.number,
  /** Function executed when input changed */
  onChange: PropTypes.func,
  /** Function executed when input is focused */
  onFocus: PropTypes.func,
  /** Function executed when input is blurred */
  onBlur: PropTypes.func,
  /** Function executed when eye icon is clicked */
  onEyeIconClick: PropTypes.func,
  /** Boolean input error */
  valid: PropTypes.bool,
  /** String input error message */
  errorMessage: PropTypes.string,
};

export default PasswordInput;
